import { eachDayOfInterval, add, startOfWeek } from 'date-fns';

export const dateSpan = (startDate: Date): Date[] => {
  return eachDayOfInterval({
    start: startOfWeek(startDate, { weekStartsOn: 1 }),
    end: add(startDate, { days: 6 }),
  });
};
